import axios from 'axios';
import config from '../../config/environmentConfig';
import { COMMON_ACTIONS } from '../../static/constants'
import { showToasterMessage } from '../../utils';
const { lang } = require('../../translations/' + (sessionStorage.getItem('language') || 'en') + '.js');

export const resendActivationLink = (payload, props) => {
  return dispatch => {
    dispatch({ type: COMMON_ACTIONS.SHOW_LOADER });
    return axios
      .get(`${config.USERS_BASE_URL}${config.API_VERSION}/${config.rootContextUsers}/onlineUser/resendActivationEmail?email=${payload.username}`)
      .then(res => {
        showToasterMessage({ messageType: 'success', description: ((res || {}).data || {}).message || 'Sent activation mail' })
        dispatch({ type: COMMON_ACTIONS.HIDE_LOADER });
        props.push({
          pathname: '/',
          state: { source: 'activation-pending' }
        });
      })
      .catch((err) => {
        if (!err.__isRetryRequest) {
          dispatch({ type: COMMON_ACTIONS.HIDE_LOADER });
          showToasterMessage({ messageType: 'error', description: lang[((err.response || {}).data || {}).message] || 'Some error occurred' });
        }
      })
  }
}